<template>
  <div class="app-layout">
    <AppSidebar />
    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>

<script>
import AppSidebar from '@/components/AppSidebar.vue'

export default {
  name: 'MainLayout',
  components: { AppSidebar }
}
</script>

<style scoped>
.app-layout {
  display: flex;
  min-height: 100vh;
  background: #fff;
}
.main-content {
  flex: 1;
  overflow-y: auto;
  background: #fff;
  min-width: 0;
}

@media (max-width: 768px) {
  .app-layout {
    flex-direction: column;
  }
}
</style>
